import { render, staticRenderFns } from "./comment-choisir-les-mots-cles-en-referencement-web.vue?vue&type=template&id=5a2f3e57&"
import script from "./comment-choisir-les-mots-cles-en-referencement-web.vue?vue&type=script&lang=js&"
export * from "./comment-choisir-les-mots-cles-en-referencement-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports